// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile Page Styles */
.profile-content {
    max-width: 800px;
  }
  
  .profile-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 2rem;
  }
  
  .profile-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-bottom: 1px solid #f8f9fa;
  }
  
  .profile-field:last-child {
    border-bottom: none;
  }
  
  .field-label {
    font-weight: 500;
    color: #6c757d;
    min-width: 150px;
  }
  
  .field-value {
    color: #333;
    font-weight: 500;
    flex-grow: 1;
    text-align: right;
  }
  
  /* Course Tabs */
  .tab-navigation-courses {
    display: flex;
    border-bottom: 2px solid #f8f9fa;
    margin-bottom: 2rem;
  }
  
  .course-tab {
    background: none;
    border: none;
    padding: 1rem 1.5rem;
    color: #6c757d;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 3px solid transparent;
  }
  
  .course-tab:hover {
    color: #333;
  }
  
  .course-tab.active {
    color: #1e3a5f;
    border-bottom-color: #1e3a5f;
  }
  
  /* Vertical Course Cards */
  .course-card-vertical {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    overflow: hidden;
    transition: box-shadow 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .course-card-vertical:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .course-image-container {
    position: relative;
    overflow: hidden;
  }
  
  .course-image-vertical {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  
  .course-content-vertical {
    padding: 1.5rem;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  
  .course-title-vertical {
    color: #333;
    font-weight: 600;
    font-size: 1.1rem;
    line-height: 1.4;
  }
  
  .course-progress-info-vertical {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
  }
  
  .progress-text {
    color: #6c757d;
    font-weight: 500;
  }
  
  .progress-percentage-vertical {
    color: #6c757d;
    font-weight: 500;
  }
  
  .progress-section-vertical {
    margin-top: auto;
  }
  
  .custom-progress-vertical {
    height: 6px;
    background-color: #e9ecef;
    border-radius: 3px;
  }
  
  .custom-progress-vertical .progress-bar {
    background-color: #1e3a5f;
    border-radius: 3px;
  }
  
  .continue-btn {
    border-color: #4fbe6c;
    color: #4fbe6c;
    font-weight: 500;
    transition: all 0.3s ease;
  }
  
  .continue-btn:hover {
    background-color: #4fbe6c;
    border-color: #4fbe6c;
    color: white;
  }
  
  /* Empty State */
  .empty-state {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 3rem;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .profile-field {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
  
    .field-value {
      text-align: left;
    }
  
    .tab-navigation-courses {
      flex-direction: column;
    }
  
    .course-tab {
      text-align: left;
      border-bottom: 1px solid #f8f9fa;
      border-right: none;
    }
  
    .course-tab.active {
      border-bottom-color: #f8f9fa;
      border-left: 3px solid #1e3a5f;
      background-color: #f8f9fa;
    }
  }
  
  @media (max-width: 576px) {
    .profile-card {
      padding: 1.5rem;
    }
  
    .course-content-vertical {
      padding: 1rem;
    }
  
    .course-image-vertical {
      height: 150px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/profile.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA,0BAA0B;EAC1B;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;IACb;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,gCAAgC;MAChC,kBAAkB;IACpB;;IAEA;MACE,4BAA4B;MAC5B,8BAA8B;MAC9B,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":["/* Profile Page Styles */\n.profile-content {\n    max-width: 800px;\n  }\n  \n  .profile-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 2rem;\n  }\n  \n  .profile-field {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 0;\n    border-bottom: 1px solid #f8f9fa;\n  }\n  \n  .profile-field:last-child {\n    border-bottom: none;\n  }\n  \n  .field-label {\n    font-weight: 500;\n    color: #6c757d;\n    min-width: 150px;\n  }\n  \n  .field-value {\n    color: #333;\n    font-weight: 500;\n    flex-grow: 1;\n    text-align: right;\n  }\n  \n  /* Course Tabs */\n  .tab-navigation-courses {\n    display: flex;\n    border-bottom: 2px solid #f8f9fa;\n    margin-bottom: 2rem;\n  }\n  \n  .course-tab {\n    background: none;\n    border: none;\n    padding: 1rem 1.5rem;\n    color: #6c757d;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-bottom: 3px solid transparent;\n  }\n  \n  .course-tab:hover {\n    color: #333;\n  }\n  \n  .course-tab.active {\n    color: #1e3a5f;\n    border-bottom-color: #1e3a5f;\n  }\n  \n  /* Vertical Course Cards */\n  .course-card-vertical {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    overflow: hidden;\n    transition: box-shadow 0.3s ease;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .course-card-vertical:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .course-image-container {\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .course-image-vertical {\n    width: 100%;\n    height: 200px;\n    object-fit: cover;\n  }\n  \n  .course-content-vertical {\n    padding: 1.5rem;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .course-title-vertical {\n    color: #333;\n    font-weight: 600;\n    font-size: 1.1rem;\n    line-height: 1.4;\n  }\n  \n  .course-progress-info-vertical {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 0.9rem;\n  }\n  \n  .progress-text {\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  .progress-percentage-vertical {\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  .progress-section-vertical {\n    margin-top: auto;\n  }\n  \n  .custom-progress-vertical {\n    height: 6px;\n    background-color: #e9ecef;\n    border-radius: 3px;\n  }\n  \n  .custom-progress-vertical .progress-bar {\n    background-color: #1e3a5f;\n    border-radius: 3px;\n  }\n  \n  .continue-btn {\n    border-color: #4fbe6c;\n    color: #4fbe6c;\n    font-weight: 500;\n    transition: all 0.3s ease;\n  }\n  \n  .continue-btn:hover {\n    background-color: #4fbe6c;\n    border-color: #4fbe6c;\n    color: white;\n  }\n  \n  /* Empty State */\n  .empty-state {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 3rem;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .profile-field {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n    }\n  \n    .field-value {\n      text-align: left;\n    }\n  \n    .tab-navigation-courses {\n      flex-direction: column;\n    }\n  \n    .course-tab {\n      text-align: left;\n      border-bottom: 1px solid #f8f9fa;\n      border-right: none;\n    }\n  \n    .course-tab.active {\n      border-bottom-color: #f8f9fa;\n      border-left: 3px solid #1e3a5f;\n      background-color: #f8f9fa;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .profile-card {\n      padding: 1.5rem;\n    }\n  \n    .course-content-vertical {\n      padding: 1rem;\n    }\n  \n    .course-image-vertical {\n      height: 150px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
